import _ from "underscore";
import React from "react";
import M from "../../../strings"
import EntityForm from "./entityForm";
import * as CustomUtils from "../../../utils/customUtils";
import { setActiveMenuItem } from "../../../actions/menu";
import { secureScreen } from "../../components/secure";

class CategoryForm extends EntityForm {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        super.componentDidMount();
        setActiveMenuItem({id: this.getSubEntity()});
    }

    getSubEntity() {
        switch (this.props.level) {
            case 0: return "macroarea";
            case 1: return "area";
            case 2: return "category";
            default: throw new Error("Unsupported category level: " + this.props.level);
        }
    }

    getGridUrl(data) {
        return `/entities/${this.getSubEntity()}`;
    }

    getGridTitle(){
        const subEntity = this.getSubEntity();
        return M(subEntity);
    }

    getTitle() {
        const items = [];
        const entity = this.getSubEntity();
        const data = this.state && this.state.data ? this.state.data : {}
        const gridTitle = this.getGridTitle();
        items.push({title:gridTitle, url : this.getGridUrl(data)});
        if (data.id && data.id !== "new") {
            items.push({title: M(["edit", entity]) + " " + " <b>" + this.generateDataDescription(data) + "</b>"});
        } else {
            items.push({title: M(["create", entity])});
        }
        return items;
        //return M(`${this.getSubEntity()}FormTitle`);
    }

    getDescriptor() {
        const descriptor = CustomUtils.deepClone(super.getDescriptor()),
            _onModelLoad = descriptor.onModelLoad;

        descriptor.onModelLoad = (model) => {
            const level = model.get("level");
            if (level === null || level === undefined) {
                model.set("level", this.props.level);
            }

            if (_onModelLoad && _.isFunction(_onModelLoad)) {
                _onModelLoad(model);
            }
        }
        return descriptor;
    }

}

export default secureScreen(CategoryForm)